import { InventoryMovementState } from "~/features/binMaintenanceWorkstation/binMaintenanceWorkstation.slice";
import {
  ConfirmInventoryMovementRequest,
  InventoryMovementResponseDto,
  NextBinResponse,
  SourceAndDestinationBinDto,
  StartBinMaintenanceRequest
} from "~/types/api";

import { warehouseApi } from "./warehouseApi";

type PostConfirmInventoryMovementParams = {
  autostoreGridId: string;
  workstationId: string;
  sourceBinId: number;
  destinationBinId: number;
};

export const autostoreBinMaintenanceApi = warehouseApi.injectEndpoints({
  endpoints: (build) => ({
    startBinMaintenance: build.mutation<
      InventoryMovementState,
      {
        autostoreGridId: string;
        workstationId: string;
      } & StartBinMaintenanceRequest
    >({
      query: ({
        autostoreGridId,
        workstationId,
        mode,
        temperatureZone,
        flaggedReasons
      }) => ({
        url: `/autostore-bin-maintenance/grid/${autostoreGridId}/workstation/${workstationId}/start-bin-maintenance`,
        method: "POST",
        body: { mode, temperatureZone, flaggedReasons }
      })
    }),
    confirmInventoryMovement: build.mutation<
      InventoryMovementResponseDto,
      PostConfirmInventoryMovementParams
    >({
      query: ({
        autostoreGridId,
        workstationId,
        sourceBinId,
        destinationBinId
      }) => {
        const request: ConfirmInventoryMovementRequest = {
          sourceBinId,
          destinationBinId
        };

        return {
          url: `/autostore-bin-maintenance/grid/${autostoreGridId}/workstation/${workstationId}/confirm-inventory-movement`,
          method: "POST",
          body: request
        };
      },
      invalidatesTags: ["inventory movements"]
    }),
    postSkipMaintenanceInventoryMovement: build.mutation<
      SourceAndDestinationBinDto,
      {
        autostoreGridId: string;
        workstationId: string;
      }
    >({
      query: ({ autostoreGridId, workstationId }) => ({
        url: `/autostore-bin-maintenance/grid/${autostoreGridId}/workstation/${workstationId}/skip-inventory-movement`,
        method: "POST"
      }),
      invalidatesTags: ["inventory movements"]
    }),
    requestNextMaintenanceBin: build.mutation<
      NextBinResponse,
      {
        autostoreGridId: Guid;
        portId: number;
      }
    >({
      query: ({ autostoreGridId, portId }) => ({
        url: `/autostore-bin-maintenance/grid/${autostoreGridId}/port/${portId}/next-bin-with-bin-configuration`,
        method: "GET"
      }),
      invalidatesTags: ["port status", "autostore task group"]
    })
  }),

  overrideExisting: false
});
